'use strict';

module.exports = require('./slider');


//////////////////
// WEBPACK FOOTER
// ./~/react-slick/lib/index.js
// module id = 1663
// module chunks = 0